import { create } from 'zustand';

interface LoopStore {
  selectionStart: number | null;
  selectionEnd: number | null;
  loopEnabled: boolean;
  setSelection: (start: number, end: number) => void;
  clearSelection: () => void;
  toggleLoop: () => void;
}

export const useLoopStore = create<LoopStore>((set) => ({
  selectionStart: null,
  selectionEnd: null,
  loopEnabled: false,

  setSelection: (start, end) => set({
    selectionStart: Math.min(start, end),
    selectionEnd: Math.max(start, end),
  }),

  clearSelection: () => set({
    selectionStart: null,
    selectionEnd: null,
    loopEnabled: false,
  }),

  toggleLoop: () => set((s) => ({ loopEnabled: !s.loopEnabled })),
}));
